import styled from 'styled-components';
export const StyledWrapper = styled.div `
  ${({ outlined, theme }) => outlined ? `box-shadow: 0 2px 6px rgba(${theme.colors.transparentBlack}, 0.26);` : ''};
  padding: 0.5rem 0;
  background: ${({ outlined }) => (outlined ? 'white' : 'transparent')};
  max-height: 12.5rem;
  overflow-y: auto;
`;
export const StyledList = styled.ul `
  list-style: none;
  margin: 0;
  padding: 0;
`;
export const StyledListItem = styled.li `
  display: flex;
`;
